import Card from './Card';

/**
 * Settings page section card. Standardises the repeated
 * `Card.settings-card` + `h2.settings-section-title` + `p.settings-section-hint`
 * pattern used across the /settings/* pages.
 *
 * Public interface: optional `title` + `hint`, with `children` for the body.
 * Hides the settings-card / section-title / section-hint class-name contract so
 * the look can change in one place.
 *
 * Props:
 *   title     — section heading (node); omit for a plain settings card
 *   hint      — descriptive sub-text under the title (node)
 *   status    — pass-through to Card ('success' | 'danger' | 'warning')
 *   className — extra class(es) appended to the card
 *
 * All other props pass through to the underlying Card root.
 */
export default function SettingsCard({
  title,
  hint,
  status,
  className = '',
  children,
  ...props
}) {
  return (
    <Card
      status={status}
      className={['settings-card', className].filter(Boolean).join(' ')}
      {...props}
    >
      {title != null && <h2 className="settings-section-title">{title}</h2>}
      {hint != null && <p className="settings-section-hint">{hint}</p>}
      {children}
    </Card>
  );
}
